// Plugins are loaded alphabetically. We start the file name with 1_ to begin monitoring as soon as possible.
import { defineNuxtPlugin, useRuntimeConfig } from "nuxt/app";
import rg4js from "raygun4js";
import { useServerLogger } from "~/composables/useServerLogger";

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const raygunKey = config.public.RAYGUN_API_KEY;

  if (process.client && raygunKey) {
    rg4js("apiKey", raygunKey);
    rg4js("enableCrashReporting", true);
    rg4js("enableRealUserMonitoring", true);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    nuxtApp.vueApp.config.errorHandler = async (error, instance, info) => {
      const user = JSON.parse(localStorage.getItem("user") ?? "{}");
      const userDetails = {
        identifier: user.email || user.id,
        isAnonymous: false,
        email: user.email,
        fullName: user.name,
      };

      try {
        if (user?.id || user?.email) {
          rg4js("setUser", userDetails);
        }

        rg4js("send", {
          error,
          customData: [{ info }],
        });
      } catch (raygunError) {
        await Promise.all([
          useServerLogger(
            raygunError as Error,
            "Error in logging to Raygun",
            userDetails,
          ),
          useServerLogger(error as Error, String(info), userDetails),
        ]);
      }
    };
  }
});
